var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWhatsMissingGreen(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 51,
    viewBox: "0 0 51 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_38_242)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47 0H4V43H47V0ZM22.0796 27.9745V28.1577H25.7443V27.9745C25.7647 26.7121 25.897 25.6585 26.1413 24.8136C26.3857 23.9686 26.7776 23.2408 27.3171 22.63C27.8567 22.009 28.5743 21.4186 29.4702 20.8587C30.366 20.309 31.1295 19.6778 31.7607 18.9652C32.402 18.2526 32.8906 17.4433 33.2266 16.5373C33.5726 15.6313 33.7457 14.6184 33.7457 13.4986C33.7457 11.9105 33.3793 10.4955 32.6463 9.25353C31.9235 8.01157 30.8954 7.03433 29.5618 6.32173C28.2384 5.60914 26.6809 5.25284 24.8892 5.25284C23.2401 5.25284 21.7385 5.5786 20.3846 6.23011C19.0409 6.88161 17.9567 7.82325 17.1321 9.05506C16.3177 10.2868 15.8698 11.768 15.7884 13.4986H19.6363C19.7178 12.2973 20.0181 11.3252 20.5373 10.582C21.0565 9.83887 21.7029 9.29425 22.4766 8.94817C23.2502 8.60202 24.0545 8.42901 24.8892 8.42901C25.8461 8.42901 26.7165 8.62748 27.5004 9.02449C28.2842 9.4215 28.9102 9.98648 29.3785 10.7194C29.8468 11.4524 30.081 12.3177 30.081 13.3154C30.081 14.1196 29.9384 14.8525 29.6534 15.5142C29.3785 16.1759 29.0019 16.7613 28.5234 17.2702C28.045 17.7691 27.5054 18.2017 26.9048 18.5682C25.9072 19.1688 25.0521 19.8254 24.3395 20.538C23.6269 21.2506 23.0772 22.1821 22.6904 23.3324C22.3035 24.4827 22.0999 26.03 22.0796 27.9745ZM22.0948 36.3881C22.6343 36.9277 23.2808 37.1974 24.0341 37.1974C24.5431 37.1974 25.0012 37.0753 25.4084 36.831C25.8257 36.5765 26.1566 36.2405 26.4009 35.8232C26.6554 35.4058 26.7827 34.9477 26.7827 34.4488C26.7827 33.6955 26.5129 33.0491 25.9733 32.5096C25.4338 31.97 24.7874 31.7003 24.0341 31.7003C23.2808 31.7003 22.6343 31.97 22.0948 32.5096C21.5553 33.0491 21.2855 33.6955 21.2855 34.4488C21.2855 35.2022 21.5553 35.8486 22.0948 36.3881Z",
    fill: "#5DEE7A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_38_242",
    x: 0,
    y: 0,
    width: 51,
    height: 51,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_38_242"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_38_242",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsMissingGreen);
export default __webpack_public_path__ + "static/media/whats-missing-green.da026c02ff0856d3171430f8b4d44155.svg";
export { ForwardRef as ReactComponent };